
define('text!templates/widgets/manager/list.ejs',[],function () { return '<li class="menu-item loading preloader">\n</li>';});

